import React from "react"
import DatesHelper from "../common/datesHelper"
import { Link } from "react-router-dom";
import { links } from "../routes";
import { getRemainingDays } from "../login/loginHelpers";
import { DropDownContainer } from "../common/components/dropDownMenu";
const expirationImage = require("../assets/images/expiration.png");
export const FreePeriodEndData = new Date(2020, 7, 31, 23, 59, 59);

export const LicenseAlertMenu: React.FC<{ expiration: Date }> = ({ expiration }) => {
    const remamingDays = getRemainingDays(expiration);
    if (remamingDays < 0)
        return <ExpirationDropdown
            navTitle="Scaduto il"
            navColor="danger"
            navIcon="fas fa-times"
            title="Abbonamento scaduto"
            expiration={expiration}
            remainingDays={remamingDays}
            buttonText="Acquista ora"
            buttonColor="success"
        />
    if (remamingDays <= 30)
        return <ExpirationDropdown
            navTitle="Scadenza"
            navColor="warning"
            navIcon="fas fa-exclamation-triangle"
            title="Abbonamento in scadenza"
            expiration={expiration}
            remainingDays={remamingDays}
            buttonText="Rinnova ora"
            buttonColor="danger"
        />
    else return <span />
}

interface Props {
    navTitle: string,
    navColor: "warning" | "secondary" | "danger",
    navIcon: string,
    expiration: Date,
    remainingDays: number,
    title: string,
    buttonText: string,
    buttonColor: "danger" | "success",
}

const ExpirationDropdown: React.FC<Props> = ({ navTitle, navColor, navIcon, expiration, remainingDays, title, buttonText, buttonColor }) => {
    return (<li className="nav-item dropdown">
        <DropDownContainer>
            {
                toggle => <>
                    <a data-bs-toggle="dropdown"
                        className="nav-link text-muted waves-effect waves-dark"
                        aria-haspopup="true"
                        aria-expanded="false"
                        onClick={toggle}
                        title={`Scadenza abbonamento ${DatesHelper.getReadableDateString(expiration)}`}>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className={`badge badge-${navColor} d-flex align-items-center`}
                                style={{ fontSize: "1rem", padding: "0.5rem" }}>
                                <i className={`${navIcon} me-3`} />
                                <div>
                                    <div style={{ fontSize: "0.8rem" }} className="mb-1">{navTitle}</div>
                                    {DatesHelper.getReadableDateString(expiration)}
                                </div>
                                <i className="fas fa-chevron-down ms-2" style={{ fontSize: "0.8rem" }} />
                            </div>
                        </div>
                    </a>
                    <div className="dropdown-menu dropdown-menu-end scale-up">
                        <ul className="dropdown-user">
                            <li>
                                <div className="text-center mb-2"><strong>{title}</strong></div>
                                <div className="dw-user-box d-flex align-items-center">
                                    <div className="u-img me-3">
                                        <img src={expirationImage} alt="expiration" />
                                    </div>
                                    <div className="u-text text-center">
                                        <strong>{DatesHelper.getReadableDateString(expiration)}</strong>
                                        {remainingDays > 0 && <h3 className="fw-bold">-{remainingDays} giorni</h3>}
                                        <Link to={links.paymentPage} className={`btn btn-rounded btn-${buttonColor} mt-3`}>
                                            {buttonText}
                                        </Link>
                                    </div>
                                </div>
                            </li>
                            <li role="separator" className="divider" />
                            <li>
                                <a href="mailto:info@caldaiemanager.it">
                                    <i className="fas fa-question-circle" /> Richiedi informazioni
                                </a>
                            </li>
                        </ul>
                    </div>
                </>
            }
        </DropDownContainer>
    </li>);

}